import { fetcher } from '../utils'
import { ComponentInfoChatVO, ComponentTemplateMessageVO } from '@repo/types'

export default async (input: ComponentTemplateMessageVO): Promise<ComponentInfoChatVO> =>
  fetcher(`/api/chats/template/send`, 'POST', input)
